import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const VIPSuccess = () => {
  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-4">
      <div className="max-w-2xl w-full text-center space-y-8">
        <div className="flex justify-center">
          <CheckCircle className="w-24 h-24 text-green-500" />
        </div>

        <div className="space-y-4">
          <h1 className="text-5xl font-bold">Welcome to VIP!</h1>
          <p className="text-xl text-gray-300">
            Your subscription is now active
          </p>
        </div>

        <div className="bg-white/5 border border-white/10 rounded-lg p-8 space-y-4 text-left">
          <h2 className="text-2xl font-semibold mb-4">What's Next?</h2>
          
          <div className="space-y-3">
            <div className="flex items-start space-x-3">
              <span className="text-red-500 font-bold">1.</span>
              <p>You'll receive a confirmation email shortly with your subscription details</p>
            </div>
            
            <div className="flex items-start space-x-3">
              <span className="text-red-500 font-bold">2.</span>
              <p>Choose your 2 instant back-catalogue tracks from the member portal</p>
            </div>
            
            <div className="flex items-start space-x-3">
              <span className="text-red-500 font-bold">3.</span>
              <p>Get 2 more tracks on the 1st of each month</p>
            </div>
            
            <div className="flex items-start space-x-3">
              <span className="text-red-500 font-bold">4.</span>
              <p>Enjoy early access to all new releases and exclusive VIP dubs</p>
            </div>
          </div>
        </div>

        <div className="flex gap-4 justify-center">
          <Link
            to="/member"
            className="px-8 py-3 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg transition-colors"
          >
            Go to Member Portal
          </Link>
          <Link
            to="/"
            className="px-8 py-3 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-lg transition-colors"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default VIPSuccess;
